import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=e322f9a2&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=ts"
export * from "./Iframe.vue?vue&type=script&lang=ts"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=e322f9a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e322f9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e322f9a2')) {
      api.createRecord('e322f9a2', component.options)
    } else {
      api.reload('e322f9a2', component.options)
    }
    module.hot.accept("./Iframe.vue?vue&type=template&id=e322f9a2&scoped=true", function () {
      api.rerender('e322f9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Iframe.vue"
export default component.exports